<template>
  <div>
    <div class="" style="display: flex;margin: 20px 0;">
      <span style="line-height: 32px">项目名称:</span>
      <el-input
        v-model="select.selectName"
        :clearable="true"
        @clear="getApplication"
        placeholder="请输入项目名称"
        style="margin-left: 10px;width: 200px;"
      ></el-input>
      <!--<span style="line-height: 32px;margin-left: 20px;">项目类型:</span>
			<el-select v-model="select.selectValue1" @clear="getApplication" clearable placeholder="请选择"
				style="width: auto;margin-left: 10px;">
				<el-option v-for="(item, index) in select.options1" :key="index" :label="item.text" :value="index">
				</el-option>
			</el-select>-->
      <span style="line-height: 32px;margin-left: 20px;">状态:</span>
      <el-select
        v-model="select.selectValue2"
        @clear="getApplication"
        clearable
        placeholder="请选择"
        style="width: auto;margin-left: 10px;"
      >
        <el-option
          v-for="(item, index) in select.options2"
          :key="index"
          :label="item.text"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-button type="primary" style="margin-left: 20px" @click="searchData">
        查询
      </el-button>

      <!--			<el-button type="primary" style="margin-left: 20px" @click="addGf">
				申报省级工法
			</el-button>-->
    </div>
    <!-- 表格 -->
    <normalTable
      v-loading="loading"
      :tabList="tabList"
      :tableList="tableList"
      @copol-click="reciveClick"
    >
    </normalTable>

    <div style="margin-top: 50px;" v-if="totalNum > 10">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getAppliInfo, getProjectType } from "../../api/moudles/application.js";

import normalTable from "../../components/table/normalTable.vue";
export default {
  data() {
    return {
      select: {
        options1: [],
        options2: [],
        selectName: "",
        selectValue1: "",
        selectValue2: "",
      },
      loading: false,
      tabList: [
        "项目名称",
        "申请时间",
        "审核时间",
        "名额",
        "已申报",
        "状态",
        "动作",
      ],
      tableList: [],
      tabCodeList: [],
      modelList: [],
      applyList: [],
      project_type: [],
      // 分页
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
    };
  },
  components: {
    normalTable,
  },
  created() {
    this.getApplication();
    this.getProjecttype();
  },
  methods: {
    // 获取下拉选项
    async getProjecttype() {
      await getProjectType({
        data: {},
        success: (res) => {
          console.log(res);
          const typeAll = res.data.typeAll;
          const statusAll = res.data.statusAll;
          const newtypeAll = [];
          const newStatusAll = [];
          Object.keys(typeAll).forEach((item, index) => {
            const newList = {};
            newList.text = typeAll[item];
            newtypeAll.push(newList);
          });
          statusAll.forEach((item, index) => {
            const newList = {};
            newList.text = item;
            newStatusAll.push(newList);
          });
          this.select.options1 = newtypeAll;
          this.select.options2 = newStatusAll;
        },
      });
    },
    searchData() {
      this.getApplication();
    },

    addGf() {
      this.$router.push({
        name: "addGf",
        params: {
          // 优秀项目经理字段为1
          type: 8,
          projectCode: "2208151800252797",
          distribution_materials: [],
        },
      });
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getApplication();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getApplication();
    },
    async getApplication() {
      const params = {
        name: this.select.selectName,
        project_type: this.select.selectValue1,
        status: this.select.selectValue2,
        page: this.currentPage,
        limit: this.pageSize,
      };
      this.loading = true;
      await getAppliInfo({
        data: params,
        success: (res) => {
          console.log(res);
          this.totalNum = res.totalCount;
          let dataList = res.data;
          // 类型列表
          let project_type = [];
          // code列表
          let upCode = [];
          // 模板列表
          let modelList = [];
          // 是否过期
          let applyList = [];
          let upList = [];
          let idList = [];
          dataList.forEach((item) => {
            let newlist = {};
            //newlist['project_type_name'] = item.project_type_name
            newlist["project_name"] = item.project_name;
            newlist["apply_time"] = item.apply_time;
            newlist["app_time"] = item.app_time;
            newlist["distribution_count"] = item.enp.distribution_count;
            newlist["collect_count"] = item.enp.collect_count;
            newlist["status_name"] = item.enp.status_name;
            // 二级管理员 能查看
            if (item.has_submit_app === 1) {
              if (item.enp.status_name == "已退回") {
                newlist["soqcol"] = ["编辑"];
              } else {
                newlist["soqcol"] = ["查看"];
              }
            } else {
              newlist["soqcol"] = ["申报"];
            }
            upCode.push(item.enp.project_code);
            upList.push(newlist);
            idList.push(item.projectApplicationId);
            applyList.push(item.can_do_app);
            project_type.push(item.project_type);
            modelList.push(item.distribution_materials);
          });
          this.modelList = modelList;
          this.tabCodeList = upCode;
          this.applyList = applyList;
          this.tableList = upList;
          this.idList = idList;
          this.project_type = project_type;
          this.loading = false;
        },
      });
    },

    // 接受子组件事件
    reciveClick(e) {
      const { key, list } = e;
      this.tabCodeList[key];
      if (list === "查看") {
        if (this.project_type[key] === "4") {
          if (e.item.project_name.indexOf("2026") !== -1) {
            //	诚信企业
            this.$router.push({
              name: "creditEnterDetail2026",
              params: {
                id: this.idList[key],
              },
            });
          } else {
            //	诚信企业
            this.$router.push({
              name: "creditEnterDetail",
              params: {
                id: this.idList[key],
              },
            });
          }
        } else {
          this.$router.push({
            name: "infodetail",
            params: {
              id: this.idList[key],
            },
          });
        }
      } else {
        if (this.applyList[key] !== 1) {
          this.$message.error("已经过了申报时间，无法申报");
          return;
        }
        if (this.project_type[key] === "4") {
          //	诚信企业
          if (e.item.project_name.indexOf("2026") !== -1) {
            this.$router.push({
              name: "creditEnterprise2026",
              params: {
                // 优秀项目经理字段为1
                type: this.project_type[key],
                projectCode: this.tabCodeList[key],
                distribution_materials: this.modelList[key],
              },
            });
          } else {
            this.$router.push({
              name: "creditEnterprise",
              params: {
                // 优秀项目经理字段为1
                type: this.project_type[key],
                projectCode: this.tabCodeList[key],
                distribution_materials: this.modelList[key],
              },
            });
          }
        } else {
          //其他
          this.$router.push({
            name: "infoadd",
            params: {
              // 优秀项目经理字段为1
              type: this.project_type[key],
              projectCode: this.tabCodeList[key],
              distribution_materials: this.modelList[key],
            },
          });
        }
      }
    },
  },
};
</script>

<style scoped="scoped"></style>
